import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

function JourneyTableRow({ baseJourney, journey }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <React.Fragment>
      <TableRow
        sx={{
          '& > *': { borderBottom: 'unset' },
        }}
      >
        <TableCell sx={{ width: '40px' }}>
          <IconButton onClick={() => setOpen(!open)} size="small">
            <FontAwesomeIcon
              icon={open ? 'fa-chevron-up' : 'fa-chevron-down'}
            />
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" sx={{ width: '100%' }}>
          {journey.start_unit}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={2}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="overline" gutterBottom>
                {t('components.patientCategoryMap.options')}
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow
                    sx={{
                      '&:last-child td, &:last-child th': { border: 0 },
                    }}
                  >
                    <TableCell>
                      {t('components.patientCategoryMap.path.end')}
                    </TableCell>
                    <TableCell align="right">
                      {t('components.patientCategoryMap.path.proportion')}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {journey.options.map((option) => {
                    const baseOption = baseJourney.options.find(
                      (i) => i.id === option.id,
                    );
                    return (
                      <TableRow key={option.id}>
                        <TableCell component="th" scope="row">
                          {option.id}
                        </TableCell>
                        <TableCell align="right">
                          {baseOption.proportion} / {option.proportion}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default JourneyTableRow;
